// @flow
import React from 'react';
import type { BannerSequence } from 'store/modules/banners';
import { fromNow } from 'lib/common';
import { Link } from 'react-router-dom';
import FakeLink from 'components/common/FakeLink';

import cx from 'classnames';

import './BannerSequences.scss';

type BannerSequenceItemProps = {
  sequence: BannerSequence,
  username: string,
  active: boolean,
};

type Props = {
  sequences: ?(BannerSequence[]),
  username: string,
  currentBannerId: string,
};

const BannerSequenceItem = ({ sequence, username, active }: BannerSequenceItemProps) => {
  const { title, body, meta, url_slug, created_at } = sequence;
  const to = `/@${username}/banners/${url_slug}`;
  return (
    <FakeLink className={cx('BannerSequenceItem', { active })} to={to}>
      <div className="date">{fromNow(created_at)}</div>
      <div className="title">
        <Link to={to}>{title}</Link>
      </div>
      <p>{(meta && meta.short_description) || body}</p>
    </FakeLink>
  );
};

const BannerSequences = ({ sequences, username, currentBannerId }: Props) => {
  if (!sequences || sequences.length === 0 || sequences.length === 1) return null;
  return (
    <div className="BannerSequences">
      <div className="wrapper">
        <h3 className="title">다른 배너 둘러보기</h3>
        {sequences.map(s => (
          <BannerSequenceItem
            key={s.id}
            sequence={s}
            username={username}
            active={s.id === currentBannerId}
          />
        ))}
      </div>
    </div>
  );
};

export default BannerSequences;



// WEBPACK FOOTER //
// ./src/components/banner/BannerSequences/BannerSequences.js